import { createContext, useContext, type ReactNode } from "react";
import type { UsuariosGateway } from "../infrastructure/usuarios.gateway";

const Contexto = createContext<UsuariosGateway | null>(null);

/**
 * Injecao de dependencia do modulo: em producao entra o gateway HTTP, no teste
 * o em memoria, e o componente nao sabe a diferenca.
 */
export function ProvedorDeUsuarios({
  gateway,
  children,
}: {
  readonly gateway: UsuariosGateway;
  readonly children: ReactNode;
}) {
  return <Contexto.Provider value={gateway}>{children}</Contexto.Provider>;
}

export function useUsuariosGateway(): UsuariosGateway {
  const gateway = useContext(Contexto);
  if (!gateway) {
    throw new Error("useUsuariosGateway precisa estar dentro de <ProvedorDeUsuarios>.");
  }
  return gateway;
}
